import { render, staticRenderFns } from "./businessPlanList.vue?vue&type=template&id=52da68b2"
import script from "./businessPlanList.vue?vue&type=script&lang=js"
export * from "./businessPlanList.vue?vue&type=script&lang=js"
import style0 from "./businessPlanList.vue?vue&type=style&index=0&id=52da68b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports